import Action from 'redux/helpers/createAction'
const name = 'keywordSavings'

export const exportDomainKeywordSavingsExcel = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_SAVINGS_DATA_EXCEL',
  domainId => ({
    domainId
  })
)

export const exportDomainKeywordSavingsCSV = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_SAVINGS_DATA_CSV',
  domainId => ({
    domainId
  })
)
